import { menuIcon } from "../components/menu-icon";

const menuButton = () => {
	const btn = document.querySelector(
		".wp-block-navigation__responsive-container-open",
	);
	if (btn) {
		btn.innerHTML = menuIcon;
		const text = document.createElement("span");
		text.innerHTML = webobj.menu_text;
		text.classList.add("menu-text");
		btn.appendChild(text);
		const menu = document.querySelector("#menu-principal");
		if (menu) {
			menu.classList.add("loaded");
		}
	}
};

export { menuButton };
